
const notifyRoutes = [
    {
        path:'message',
        name:'notify-message',
        component: () => import(/* webpackChunkName: "about" */ '@/views/notify/message.vue')
    },
    {
        path: 'post',
        name:'notify-post',
        component: () => import(/* webpackChunkName: "about" */ '@/views/notify/post.vue')
    }
]
export default notifyRoutes